import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-textile', {
    lineHeight: '1.5em',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
});

cssRule('.tb-textile p:first-child', {
    margin: 0,
});

cssRule('.tb-textile a', {
    color: applyColor(DesignTokens.color.link.inline.default.active, '#1a699e'),
});

cssRule('.tb-textile img', {
    maxWidth: '100%',
});

cssRule('.tb-textile-editor-textarea', {
    outline: 0,
    font: 'inherit',
    border: '1px solid ' + applyColor(DesignTokens.color.elevation.border.default.default, '#b2b2b2'),
    padding: '6px',
    resize: 'vertical',
    lineHeight: '1.5em',
    height: '300px',
});

cssRule('.tb-textile-preview-container', {
    maxHeight: '300px',
    overflow: 'auto',
});

